import React, { useState } from 'react';
import './AboutSection.css';

const AboutSection = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <section className="about-section">
      <div className="logo-footer">
        <div className="logo">
          <span className="logo-text">
            <span className="logo-ba">ba</span>
            <span className="logo-ji">ji</span>
          </span>
          <div className="logo-badge">
            <svg width="20" height="26" viewBox="0 0 28 36" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path 
                d="M14 2L3 7V16C3 23 6.5 29.5 14 34C21.5 29.5 25 23 25 16V7L14 2Z" 
                fill="url(#goldGradient2)"
                stroke="#D4AF37"
                strokeWidth="0.8"
              />
              <defs>
                <linearGradient id="goldGradient2" x1="14" y1="2" x2="14" y2="34" gradientUnits="userSpaceOnUse">
                  <stop offset="0%" stopColor="#FFD700" />
                  <stop offset="50%" stopColor="#D4AF37" />
                  <stop offset="100%" stopColor="#B8860B" />
                </linearGradient>
              </defs>
            </svg>
          </div>
        </div>
        <p className="tagline">Baji.live is a King</p>
        <p className="copyright">© 2024 Baji. All Rights Reserved.</p>
        <p className="disclaimer">
          Baji.live is operated by TechSolutions N.V. and is licensed by Curacao eGaming. Gambling can be addictive. Play responsibly.
        </p>
      </div>
    </section>
  );
};

export default AboutSection;
